module.exports = __webpack_public_path__ + "img/cut_sc1.61856e21.jpg";